import { render, staticRenderFns } from "./hospitalApprovalSummaryDetails.vue?vue&type=template&id=720b3a04&scoped=true&"
import script from "./hospitalApprovalSummaryDetails.vue?vue&type=script&lang=js&"
export * from "./hospitalApprovalSummaryDetails.vue?vue&type=script&lang=js&"
import style0 from "./hospitalApprovalSummaryDetails.vue?vue&type=style&index=0&id=720b3a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720b3a04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
